package team.platforma.auth_domain

import team.platforma.auth_domain.use_cases.UserNetworkUseCase

data class UserUseCase(
    val network: UserNetworkUseCase
)
